import React, { useState, useEffect } from 'react';
import KernteamLayout from '../../KernteamLayout';
import { host_url } from '../../App';
import BackArrow from '../../BackArrow';

function KindHinzufuegen() {
    const [name, setName] = useState('');
    const [zeltId, setZeltId] = useState('');
    const [zelte, setZelte] = useState([]);
    const [tshirtSize, setTshirtSize] = useState('');
    const [feedback, setFeedback] = useState({ message: '', type: '' });
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        const fetchZelte = async () => {
            try {
                const response = await fetch(`${host_url}/zelte`);
                if (!response.ok) throw new Error('Zelte konnten nicht geladen werden.');
                const data = await response.json();
                setZelte(data);
            } catch (error) {
                setFeedback({ message: error.message, type: 'error' });
            }
        };
        fetchZelte();
    }, []);

    const handleSubmit = async (event) => {
        event.preventDefault();
        setIsLoading(true);
        setFeedback({ message: '', type: '' });

        try {
            const response = await fetch(`${host_url}/kinder`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ name, zeltId, Tshirtsize: tshirtSize }), // Tshirtsize included
            });
            const data = await response.json();
            if (!response.ok) throw new Error(data.message || 'Fehler beim Hinzufügen des Kindes.');
            setFeedback({ message: data.message || 'Kind erfolgreich hinzugefügt!', type: 'success' });
            setName('');
            setZeltId('');
            setTshirtSize(''); // Reset T-Shirt size
        } catch (error) {
            setFeedback({ message: error.message, type: 'error' });
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <KernteamLayout>
            <div className="container">
                <BackArrow to="/kinder" />
                <h1 className="section-title kinder">Kind hinzufügen</h1>
                {feedback.message && <p className={`feedback ${feedback.type}`}>{feedback.message}</p>}
                <form onSubmit={handleSubmit} className="kind-hinzufuegen-form">
                    <div className="form-group">
                        <label htmlFor="name">Name des Kindes</label>
                        <input type="text" id="name" value={name} onChange={(e) => setName(e.target.value)} required />
                    </div>
                    <div className="form-group">
                        <label htmlFor="zeltId">Zelt</label>
                        <select id="zeltId" value={zeltId} onChange={(e) => setZeltId(e.target.value)} required>
                            <option value="" disabled>Bitte wähle ein Zelt aus</option>
                            {zelte.map(zelt => (
                                <option key={zelt.ZeltID} value={zelt.ZeltID}>{zelt.Zeltname}</option>
                            ))}
                        </select>
                    </div>
                    <div className="form-group">
                        <label htmlFor="tshirtSize">T-Shirt Größe (optional)</label>
                        <select id="tshirtSize" value={tshirtSize} onChange={(e) => setTshirtSize(e.target.value)}>
                            <option value="" disabled>Bitte wähle eine Größe</option>
                            <option value="XS">XS</option>
                            <option value="S">S</option>
                            <option value="M">M</option>
                            <option value="L">L</option>
                            <option value="XL">XL</option>
                        </select>
                    </div>
                    <button type="submit" disabled={isLoading}>
                        {isLoading ? 'Hinzufügen...' : 'Kind hinzufügen'}
                    </button>
                </form>
            </div>
        </KernteamLayout>
    );
}

export default KindHinzufuegen;







